<sf-filter (searchFired)="search()" (resetFired)="reset()" [isCollapsed]="true">
    <form class="mb-2" [formGroup]="form">
        <div class="row">
            <div class="col-md-6">
                <sf-input
                    label="Search"
                    inputId="searchTerm"
                    placeholder="Search name or email"
                    formControlName="searchTerm"
                ></sf-input>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <sf-switch label="Show Deleted" inputId="deleted" formControlName="isDeleted"></sf-switch>
            </div>
        </div>
    </form>
</sf-filter>
